module.exports = __webpack_public_path__ + "static/leviathan-4def22bece8e5e35a613e744e46389e8.png";